<template>
  <span>
    <b-avatar
      size="40px"
      :text="label"
      :variant="variant"
      :class="styles"
      badge
      badge-top
      badge-variant="variant"
    >
      <template #badge>
        <iconMedic v-if="status === 'M'"
          class="alerIcon"
          width="20"
          height="20"
        />
        <iconPolice v-else-if="status === 'P'"
          class="alerIcon"
          width="20"
          height="20"
        />
        <iconFire v-else-if="status === 'B'"
          class="alerIcon"
          width="20"
          height="20"
          iconColor="#bb0d0d"
        />
        <iconContact v-else-if="status === 'C'"
          class="alerIcon"
          width="20"
          height="20"
        />
      </template>
    </b-avatar>
  </span>
</template>
<script>
import {
  BAvatar
} from 'bootstrap-vue'
import iconFire from '@core/spore-components/icons/iconFire'
import iconContact from '@core/spore-components/icons/iconContact'
import iconPolice from '@core/spore-components/icons/iconPolice'
import iconMedic from '@core/spore-components/icons/iconMedic'

export default {
  components: {
    BAvatar,
    iconFire,
    iconContact,
    iconPolice,
    iconMedic
  },
  props: {
    label: String,
    status: {
      type: String,
      required: true
    }
  },
  computed: {
    styles () {
      return this.status === 'S' ? 'avatar-no-alert' : 'avatar-alert'
    },
    variant () {
      return this.status === 'S' ? 'light-success' : 'light-danger'
    }
  }
}
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/spore-components/avatarMarker.scss";
</style>
